// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfAanvragenPortefeuilleGetPortefeuilleMaatschappijenDto } from '../model/collectionResultOfAanvragenPortefeuilleGetPortefeuilleMaatschappijenDto.ts';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails.ts';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails.ts';

import type { PortefeuilleGetParams } from '../model/portefeuilleGetParams.ts';

import type { Result1OfAanvragenPortefeuilleGetCrvpDto } from '../model/result1OfAanvragenPortefeuilleGetCrvpDto.ts';

import type { Result1OfAanvragenPortefeuilleGetPortefeuilleDashboardDto } from '../model/result1OfAanvragenPortefeuilleGetPortefeuilleDashboardDto.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Portefeuille.Inzien</li></ul>
 * @summary Haalt de CRVP op voor het huidige jaar.
 */
export const portefeuilleGetCrvp = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Result1OfAanvragenPortefeuilleGetCrvpDto>(
    { url: `/api/v1/portefeuille/crvp`, method: 'GET', signal },
    options,
  );
};

export const getPortefeuilleGetCrvpQueryKey = () => {
  return ['api', 'v1', 'portefeuille', 'crvp'] as const;
};

export const getPortefeuilleGetCrvpQueryOptions = <
  TData = Awaited<ReturnType<typeof portefeuilleGetCrvp>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof portefeuilleGetCrvp>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPortefeuilleGetCrvpQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portefeuilleGetCrvp>>> = ({ signal }) =>
    portefeuilleGetCrvp(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof portefeuilleGetCrvp>>,
    TError,
    TData
  >;
};

export type PortefeuilleGetCrvpQueryResult = NonNullable<
  Awaited<ReturnType<typeof portefeuilleGetCrvp>>
>;
export type PortefeuilleGetCrvpQueryError = ErrorType<void>;

/**
 * @summary Haalt de CRVP op voor het huidige jaar.
 */

export function usePortefeuilleGetCrvp<
  TData = Awaited<ReturnType<typeof portefeuilleGetCrvp>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portefeuilleGetCrvp>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortefeuilleGetCrvpQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Portefeuille.Inzien</li></ul>
 */
export const portefeuilleGet = (
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  params?: MaybeRefOrGetter<PortefeuilleGetParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  adviseurnummer = toValue(adviseurnummer);
  params = toValue(params);

  return customInstance<Result1OfAanvragenPortefeuilleGetPortefeuilleDashboardDto>(
    { url: `/api/v1/portefeuille/${adviseurnummer}`, method: 'GET', params, signal },
    options,
  );
};

export const getPortefeuilleGetQueryKey = (
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  params?: MaybeRefOrGetter<PortefeuilleGetParams>,
) => {
  return ['api', 'v1', 'portefeuille', adviseurnummer, ...(params ? [params] : [])] as const;
};

export const getPortefeuilleGetQueryOptions = <
  TData = Awaited<ReturnType<typeof portefeuilleGet>>,
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
>(
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  params?: MaybeRefOrGetter<PortefeuilleGetParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof portefeuilleGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPortefeuilleGetQueryKey(adviseurnummer, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portefeuilleGet>>> = ({ signal }) =>
    portefeuilleGet(adviseurnummer, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(adviseurnummer) !== null && toValue(adviseurnummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof portefeuilleGet>>, TError, TData>;
};

export type PortefeuilleGetQueryResult = NonNullable<Awaited<ReturnType<typeof portefeuilleGet>>>;
export type PortefeuilleGetQueryError = ErrorType<
  MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails | void
>;

export function usePortefeuilleGet<
  TData = Awaited<ReturnType<typeof portefeuilleGet>>,
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
>(
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  params?: MaybeRefOrGetter<PortefeuilleGetParams>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof portefeuilleGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortefeuilleGetQueryOptions(adviseurnummer, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Portefeuille.Inzien</li></ul>
 */
export const portefeuilleGetMaatschappijen = (
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  adviseurnummer = toValue(adviseurnummer);

  return customInstance<CollectionResultOfAanvragenPortefeuilleGetPortefeuilleMaatschappijenDto>(
    { url: `/api/v1/portefeuille/${adviseurnummer}/maatschappijen`, method: 'GET', signal },
    options,
  );
};

export const getPortefeuilleGetMaatschappijenQueryKey = (
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'portefeuille', adviseurnummer, 'maatschappijen'] as const;
};

export const getPortefeuilleGetMaatschappijenQueryOptions = <
  TData = Awaited<ReturnType<typeof portefeuilleGetMaatschappijen>>,
  TError = ErrorType<void>,
>(
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portefeuilleGetMaatschappijen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPortefeuilleGetMaatschappijenQueryKey(adviseurnummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof portefeuilleGetMaatschappijen>>> = ({
    signal,
  }) => portefeuilleGetMaatschappijen(adviseurnummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(adviseurnummer) !== null && toValue(adviseurnummer) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof portefeuilleGetMaatschappijen>>, TError, TData>;
};

export type PortefeuilleGetMaatschappijenQueryResult = NonNullable<
  Awaited<ReturnType<typeof portefeuilleGetMaatschappijen>>
>;
export type PortefeuilleGetMaatschappijenQueryError = ErrorType<void>;

export function usePortefeuilleGetMaatschappijen<
  TData = Awaited<ReturnType<typeof portefeuilleGetMaatschappijen>>,
  TError = ErrorType<void>,
>(
  adviseurnummer: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof portefeuilleGetMaatschappijen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPortefeuilleGetMaatschappijenQueryOptions(adviseurnummer, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
